import React, {useState, useEffect, Fragment, useCallback, useContext} from 'react';
import Layout from "../../../../../components/sales/layout/layout";
import TableSection from "../../../../../components/sales/tableSection/tableSection";
import {BaseUrl} from "../../../../../contexts/baseUrl/baseUrl";
import {Button} from "react-bootstrap";
import Images from "../../../../../assets/images/imageData";
import localization from "../../../../../assets/localization/localization";
import {Link} from "react-router-dom";

const B2CLoggedIn = ({
    caseListRequest,
    match,
     caseListResponse = [],
}) => {

    const {baseUrl} = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [listData, setListData] = useState();
    const [showDisbursedModal, setShowDisbursedModal] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        (async () => {
            await caseListRequest(0, 1, 'LOGGED_IN', 'B2C')
        })();
        setIsLoading(false);
    }, []);


    const headers = [
        'Customer Name',
        'Customer Phone Number',
        'Vehicle Registration Number',
        'Vehicle Brand Name',
        'Vehicle Model Name',
        'Vehicle Registration Date',
        'Case Category',
        'Status',
        'Action'
    ];

    const onPageChange = async (val) => {
        setIsLoading(true);
        await caseListRequest(0, val.selected + 1, 'LOGGED_IN', 'B2C');
        setIsLoading(false);
    };

    useEffect(() => {
        if (
            caseListResponse &&
            caseListResponse?.data &&
            caseListResponse?.data?.resultSets &&
            caseListResponse?.data?.resultSets.length > 0
        ) {
            const tableData = [
                'id',
                'customer_name',
                'customer_phone_number',
                'vehicle_registration_number',
                'vehicle_brand_name',
                'vehicle_model_name',
                'vehicle_registration_date',
                'case_category',
                'application_state'
            ];

            const data = caseListResponse?.data?.resultSets.map((element) => {
                const actions = [
                    { name: 'View Details', link: `${baseUrl}/ucd/b2c-case-view` }
                ];

                // Show Edit Case only if application_state = LOGGED_IN
                if (element?.application_state === "LOGGED_IN") {
                    actions.push({ name: 'Edit Case', link: `${baseUrl}/ucd/b2c-edit` });
                }
                if (element?.application_state === "LOGGED_IN" && element?.account_verification_status == null) {
                    actions.push( { name: 'PennyDrop', link: `${baseUrl}/ucd/case/account-penny-drop` });
                }
                if(element?.application_state === "APPROVED" && element?.case_category == "CAT_A") {
                    actions.push({ name: 'Add Tranches', link: `${baseUrl}/ucd/case/payment-raise-v2` })
                }
                // if(element?.application_state === "PAYMENT_DETAILS_ADDED" && element?.case_category == "CAT_A") {
                //     actions.push( { name: 'Payment Raise', link: `${baseUrl}/ucd/case/payment-raise-v2` })
                // }
                if((element?.application_state === "REQUEST_FOR_PAYMENT_RELEASE_APPROVED" && element?.case_category == "CAT_A") || (element?.application_state === "PARTIAL_PAYMENT_RELEASED" && element?.case_category == "CAT_A")) {
                    actions.push({ name: 'Tranches to Release Request', link: `${baseUrl}/ucd/case/loan-tranche-release-request` })
                }

                // parseInt(roleId) === 41 // ? { name: 'Payment Raise', link: ${baseUrl}/ucd/case/payment-raise-v2 } // : "", // parseInt(roleId) === 54 // ? { name: 'PennyDrop', link: ${baseUrl}/ucd/case/account-penny-drop } // : "", // parseInt(roleId) === 54 || parseInt(roleId) === 41 // ? { name: 'Tranches to Release Request', link: ${baseUrl}/ucd/case/loan-tranche-release-request } // : ""

                return Object.assign(
                    ...tableData.map((key) =>
                        key === 'unique_id'
                            ? { [key]: element['id'] }
                            : { [key]: element[key] }
                    ),
                    { Action: actions }
                );
            });

            if (data) {
                setListData(data);
            }
            setPageCount(Math.ceil(caseListResponse?.data?.total / caseListResponse?.data?.per_page));
        }
    }, [caseListResponse]);

    // const headerBtns = () => {
    //     return (
    //         <>
    //             <Fragment>
    //                 <Link
    //                     to={`${baseUrl}/ucd/b2c-case-without-dealer`}
    //                     className="btn btn-primary d-md-inline-block"
    //                 >
    //                     {"Add Case"}
    //                     <img src={Images?.ArrowRight} alt="" />
    //                 </Link>
    //             </Fragment>
    //         </>
    //     );
    // }

    return (
        <>
            <Layout
                title={"Case Listing"}
                isLoading={isLoading}
                isGoback={true}
                // Buttons={headerBtns}
            >
                <TableSection
                    data={listData}
                    isId={false}
                    isMngId={false}
                    headers={headers}
                    pageCount={pageCount}
                    onPageChange={onPageChange}
                    detailList={caseListResponse?.data?.resultSets}
                    srNo={caseListResponse?.data?.from}
                />
            </Layout>
        </>
    )
};

export default B2CLoggedIn;
